import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {range} from 'lodash';
import {GreatForm} from 'components/common';
import {InputField} from 'components/common/rc-fields';
import {createQuestion, updateQuestion} from 'api/question';

const QuestionForm = ({form, initialValues, onCancel, onSubmitSuccess, quizId}) => {
  const isUpdate = !isEmpty(initialValues);
  const {title, singleSelect, answer} = initialValues || {};
  const {options} = singleSelect || [];
  const [optionNum, setOptionNum] = useState(4);

  return (
    <GreatForm
      form={form}
      onCancel={onCancel}
      submitFn={
        isUpdate
          ? (payload) => updateQuestion({id: initialValues.id, ...payload})
          : (payload) => createQuestion({quizId, ...payload})
      }
      onSuccess={onSubmitSuccess}
      successMsg={`Question has been ${isUpdate ? 'updated' : 'created'} successfully`}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputField
            name="title"
            label="Title"
            initialValue={title || ''}
            rules={[{required: true, message: 'Please enter question title'}]}
            form={form}
          />
        </Grid>
        {isUpdate
          ? options.map((option, idx) => {
              return (
                <Grid item xs={12} md={6}>
                  <InputField
                    key={`option ${idx + 1}`}
                    name={`option ${idx + 1}`}
                    label={`Option ${idx + 1}`}
                    initialValue={option}
                    form={form}
                    rules={idx <= 1 ? [{required: true, message: 'Please enter the question option'}] : undefined}
                  />
                </Grid>
              );
            })
          : range(1, optionNum + 1).map((num) => {
              return (
                <Grid item xs={12} md={6}>
                  <InputField
                    key={`option ${num + 1}`}
                    name={'option' + num}
                    label={'Option' + num}
                    initialValue={''}
                    form={form}
                    rules={num <= 2 ? [{required: true, message: 'Please enter the question option'}] : undefined}
                  />
                </Grid>
              );
            })}

        <Grid item xs={12}>
          <InputField
            name="answer"
            label="Answer"
            initialValue={answer || ''}
            form={form}
            rules={[{required: true, message: 'Please enter the question answer'}]}
          />
        </Grid>
      </Grid>
    </GreatForm>
  );
};

QuestionForm.propTypes = {
  form: formShape.isRequired,
  initialValues: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmitSuccess: PropTypes.func.isRequired,
  quizId: PropTypes.string,
};

QuestionForm.defaultProps = {
  initialValues: {},
};

export default createForm()(QuestionForm);
